import { SET_MODAL } from '../constants';

const initialState = {
  showingUp: {},
  showed: [],
  modalData: {}, // <-- aquí guardarás los datos adicionales de cada modal
};

export const modals = (state = initialState, action) => {
  switch (action.type) {
    case SET_MODAL: {
      const { key, val, data = {} } = action;
      const newState = {
        ...state,
        showingUp: {
          ...state.showingUp,
          [key]: val,
        },
        modalData: {
          ...state.modalData,
          [key]: data,
        },
      };

      if (!val && !state.showed.includes(key)) {
        newState.showed = [...state.showed, key];
      }

      return newState;
    }
    default:
      return state;
  }
};
